import { AuthState, defaultAuthState } from './auth/model';

export interface RootState {
  auth: AuthState;
}

export const initialState: RootState = {
  auth: defaultAuthState,
};
